import { defineMessages } from 'react-intl';

const messages = defineMessages({
  withoutProductImageAlt: {
    id: 'modules.CatalogV2.pages.Product.components.Info.withoutProductNameAlt',
    defaultMessage: 'Foto do produto',
  },
  skuLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Info.skuLabel',
    defaultMessage: 'SKU',
  },
  deliveryNationalWideTag: {
    id: 'modules.CatalogV2.pages.Product.components.Info.deliveryNationalWideTag',
    defaultMessage: 'Entrega para todo o Brasil',
  },
});

export default messages;
